import { IPbScripts } from "@pageBuilder/typings";

export class PbScriptsService {

    public static get scripts(): IPbScripts | null {
        return window["__truSites"] as IPbScripts ?? null;
    }

}
